import { getCookie } from './getCookie';

const metrics = () => {
  /* Установка метрики по клику на кнопку телеграмма */
  (() => {
    const buttonsTelegram = document.querySelectorAll('.TelegramClickSZ');

    buttonsTelegram.forEach((button) => {
      button.addEventListener('click', () => {
        ym(94760218, 'reachGoal', 'TelegramClickSZ');
      });
    });
  })();

  /* Установка на бота _ym_uid из cookie */
  (() => {
    const buttonsBot = document.querySelectorAll('.TelegramBotClick');
    let cookie = getCookie('_ym_uid'),
      session = sessionStorage.getItem('ym_uid');

    if (
      (buttonsBot.length > 0 && cookie) ||
      (buttonsBot.length > 0 && session)
    ) {
      buttonsBot.forEach((button) => {
        if (cookie) {
          button.setAttribute(
            'href',
            button.getAttribute('href') + '?_ym_uid=' + cookie
          );
        } else if (session) {
          button.setAttribute(
            'href',
            button.getAttribute('href') + '?_ym_uid=' + session
          );
        }
      });
    }
  })();

  /* Установка метрики по клику на "Зарегистрироваться" или “Начать зарабатывать” на странице https://dpo.edu-sigma.ru/referralprogram */
  (() => {
    const refButtonsReg = document?.querySelectorAll('.ref-goal-1'),
      refButtonsEnter = document?.querySelector('.ref-goal-2'),
      refButtonsProgramm = document?.querySelectorAll('.ref-goal-3');

    refButtonsReg?.forEach((button) => {
      button?.addEventListener('click', () => {
        ym(94760218, 'reachGoal', 'referral_registration_click');
      });
    });

    /* Установка метрики по клику на "Войти" на странице https://dpo.edu-sigma.ru/referralprogram */
    refButtonsEnter?.addEventListener('click', () => {
      ym(94760218, 'reachGoal', 'referral_login_click');
    });

    /* Клик по кнопкам "Реферальная программа" на всем сайте https://dpo.edu-sigma.ru */
    refButtonsProgramm?.forEach((button) => {
      button?.addEventListener('click', () => {
        ym(94760218, 'reachGoal', 'referral_program_click');
      });
    });
  })();
};

export default metrics;
